import pages from './pages/zh-CN/pages';
import industries from './industry/zh-CN';

export default {
  ...pages,
  ...industries,
  "menu.esign": "在线签名",
  "menu.esign.esign-index": "在线签名",
  "menu.welcome": "欢迎使用",
  "menu.home": "首页",
  "menu.layout": "首页",
  "menu.company-management": "公司管理",
  "menu.company-management.info": "公司信息",
  "menu.company-management.add": "添加公司",
  "menu.company-management.base": "添加公司",
  "menu.company-management.nda": "签署保密协议",
  "menu.company-management.due-diligence-form": "尽职调查问卷",
  "menu.company-management.aml-ctf-scp-questionnaire": "反洗钱/反恐怖融资/制裁问卷",
  "menu.company-management.contract-management": "合同管理",
  "xch_00019": "状态",
  "xch_00030": "姓名",
  "xch_00031": "性别",
  "xch_00032": "国家",
  "xch_00046": "证明详情",
  "xch_00050": "确定",
  "xch_00052": "保存",
  "xch_00086": "取消",
  "xch_00112": "确认",
  "xch_00115": "您的余额不足",
  "xch_00116": "请先充值资金到您的钱包",
  "xch_00135": "您有批量转账处于待付款状态，请继续完成付款或取消付款后再上传新批次。",
  "xch_00136": "您有批量转账处于转账处理状态，请耐心等待转账完成再上传新批次。",
  "xch_00150": "导出",
  "xch_00156": "抱歉，您的转账数量超过了我们支持的最多 {0} 条。请删除一些转账，然后再次上传。",
  "xch_00157": "抱歉，我们没有在您上传的文件中读取到任何转账数据。请您确保上传的文件正确无误后再上传。",
  "xch_00160": "成功",
  "xch_00161": "失败",
  "xch_00162": "已取消",
  "xch_00172": "基本信息",
  "xch_00174": "类型",
  "xch_00175": "问题国",
  "xch_00178": "地址",
  "xch_00180": "城市",
  "xch_00191": "州/省",
  "xch_00193": "国籍",
  "xch_00194": "职业",
  "xch_00208": "暂时无力支付",
  "xch_00209": "因为未能以「跨币种交易模式」（结算时间是工作日星期一至星期五 9：30-16：00，UTC+08：00）执行此批量转账而支付失败。请在结算时间内再尝试发起支付或使用「同币种交易模式」（结算时间是 7x 24 小时）。有任何疑问可以联系我们。",
  "xch_00248": "导出 {0} 个项目",
  "xch_00249": "导出 {0} 个项目",
  "xch_00250": "模板",
  "xch_00251": "自定义数据列",
  "xch_00252": "可用列",
  "xch_00253": "显示列",
  "xch_00255": "因为网络波动问题上传失败，请您重新上传一次。",
  "xch_00256": "退出登录",
  "xch_00257": "授权失败，请重新登录",
  "xch_00258": "重新登录",
  "xch_00302": "换汇",
  "xch_00308": "低成本模式",
  "xch_00309": "快速模式",
  "xch_00332": "支持低成本换汇",
  "xch_00333": "支持快速换汇",
  "xch_00353": "自己",
  "xch_00354": "父母",
  "xch_00355": "配偶",
  "xch_00356": "子女",
  "xch_00357": "兄弟姐妹",
  "xch_00362": "男",
  "xch_00371": "街道",
  "xch_00373": "邮政编码",
  "xch_00376": "汇率已发生变化",
  "xch_00377": "由于国际外汇市场实时波动，汇率已发生变化。请重新确认汇率报价。",
  "xch_00379": "签发日期",
  "xch_00387": "我们已经全面升级为同币种（CNY）交易模式，支持7×24小时即时转账。批量转账前，请先将外币兑换至人民币钱包。如果您有任何疑问，可以联系我们的客户成功经理。",
  "xch_00388": "知道了",
  "xch_00404": "当前暂不可换汇",
  "xch_00405": "{0} 时可以换汇，请在这个时间段内重试。",
  "xch_00429": "已拒绝",
  "xch_00430": "更改密码",
  "xch_00433": "待下发",
  "xch_00434": "待审核",
  "xch_00435": "待补充材料",
  "xch_00438": "根据合作银行的反洗钱要求，以确保不断使用我们的服务 请在48小时内提交收款人",
  "xch_00439": "和付款人",
  "xch_00440": "的证明。",
  "xch_00442": "收款人是付款人的",
  "xch_00443": "附录材料",
  "xch_00444": "请选择要认证的证件类型",
  "xch_00445": "付款人证件",
  "xch_00446": "结婚证书",
  "xch_00447": "亲属关系承诺函",
  "xch_00448": "户口本",
  "xch_00449": "赡养公证书",
  "xch_00450": "出生证明",
  "xch_00451": "雇佣合同",
  "xch_00452": "收入证明",
  "xch_00453": "在职证明",
  "xch_00454": "工资流水",
  "xch_00455": "纳税证明",
  "xch_00456": "兄弟姐妹",
  "xch_00457": "子孙女、外子孙女",
  "xch_00465": "请上传",
  "xch_00466": "模板",
  "xch_00467": "例如如下",
  "xch_00472": "关系不能为其他人，如需补充材料，请联系客户经理",
  "xch_00473": "在线签名",
  "xch_00474": "提交前请签名。",
  "xch_00475": "在线签名",
  "xch_00479": "刷新亲属承诺函的状态",
  "xch_00480": "刷新",
  "xch_00481": "XC模式",
  "xch_00482": "欢迎使用",
  "xch_00499": "支持XC换汇",
  "xch_00510": "如果您知道收款人的银行账户信息，您可以直接将款项转入他们的银行账户。",
  "xch_00511": "收款人收款信息：",
  "xch_00512": "收款人全名（中文）",
  "xch_00513": "收款人性别",
  "xch_00514": "收款人国籍",
  "xch_00515": "收款人职业",
  "xch_00516": "收款人邮政编码",
  "xch_00517": "收款人省份",
  "xch_00518": "收款人城市",
  "xch_00519": "付款地府或地区",
  "xch_00520": "收款人详细地址",
  "xch_00521": "收款人电话号码",
  "xch_00522": "收款人身份证号码",
  "xch_00523": "身份证有效期始",
  "xch_00524": "身份证有效期末",
  "xch_00525": "收款人银行账号",
  "xch_00526": "如果你知道收款人的银行详细信息，就可以直接将钱转入他们的银行账户。",
  "xch_00527": "收款人全名（中文）",
  "xch_00535": "经典模式",
  "xch_00536": "简洁模式",
  "xch_00551": "交易速度较快，但汇率不是最佳的",
  "xch_00552": "汇率较佳，但是交易速度不是最快的",
  "xch_00553": "交易速度和汇率都是最佳的",
  "xch_00563": "交易模式解释",
  "xch_00568": "邮箱",
  "xch_00574": "请输入{0}",
  "xch_00581": "操作成功",
  "xch_00582": "操作失败",
  "xch_00618": "完成",
  "xch_00619": "调拨中",
  "xch_00620": "支持经典模式下发",
  "xch_00621": "支持简洁模式下发",
  "xch_00623": "转账中",
  "xch_00647": "英文姓氏",
  "xch_00648": "姓氏",
  "xch_00649": "英文名",
  "xch_00650": "名",
  "xch_00651": "出生日期",
  "xch_00652": "证件号码",
  "xch_00653": "证件过期时间",
  "xch_00654": "女",
  "xch_00655": "背面",
  "xch_00656": "正面",
  "xch_00657": "侧面",
  "xch_00665": "此项为必填项",
  "xch_00669": "预览",
  "xch_00674": "选择要提交的证明材料",
  "xch_00693": "请检查是否填写完整",
  "xch_00736": "补充材料",
  "xch_00769": "预付款",
  "xch_00770": "全款",
  "xch_00771": "尾款",
  "xch_00772": "其他",
  "xch_00779": "驳回",
  "xch_00780": "店铺网站",
  "xch_00800": "根据合作银行的反洗钱要求，为了保证我们服务的持续使用，请在48小时内提交收款人{0}的身份证照片。",
  "xch_00801": "上传中国居民身份证",
  "xch_00802": "人像面",
  "xch_00803": "国徽面",
  "xch_00804": "注意：请不要使用卡套或涂改液遮挡证件",
  "xch_00805": "方向错误",
  "xch_00806": "拍摄不全",
  "xch_00807": "反光强烈",
  "xch_00808": "模糊不清",
  "xch_00810": "身份证明",
  "xch_00811": "交易证明",
  "xch_00813": "由于地方法规要求需要提供收款人身份证信息，以确保您的汇款安全。",
  "xch_00814": "根据境内银行和监管要求，您需要在后台提供交易证明材料，以确保您的汇款安全。",
  "xch_00823": "未能获取信息",
  "xch_00830": "公司注册地",
  "xch_00831": "公司名称",
  "xch_00832": "公司网站",
  "xch_00833": "公司所属行业",
  "xch_00834": "基本信息",
  "xch_00835": "公司注册证明文件",
  "xch_00836": "股权架构图",
  "xch_00837": "董事及公司受益人的有效证件文件和有效地址证明文件",
  "xch_00838": "实际控制人身份信息",
  "xch_00839": "持牌证明文件",
  "xch_00843": "NDA 文件",
  "xch_00844": "上一步",
  "xch_00846": "填写公司基本信息",
  "xch_00850": "公司详细资料",
  "xch_00854": "在线签署",
  "xch_00858": "调查问卷",
  "xch_00889": "提交",
  "xch_00890": "提交成功",
  "xch_00893": "保存成功",
  "xch_00895": "重新提交",
  "xch_00934": "当前进度",
  "xch_00935": "银行/数字银行",
  "xch_00936": "支付公司",
  "xch_00937": "汇款公司",
  "xch_00938": "其他机构（请填写）",
  "xch_00940": "请仔细阅读并{0}相关信息，并在文档末尾{1}填写您的个​​人信息。",
  "xch_00941": "填写",
  "xch_00943": "已完成，下一步",
  "xch_00944": "已清分",
  "xch_00945": "已退款",
  "xch_00949": "商业登记证复件",
  "xch_00950": "公司周年申报表/公司法团成立表",
  "xch_00951": "公司章程",
  "xch_00952": "公司办公场地照片",
  "xch_00953": "反洗钱/反恐融资政策",
  "xch_00954": "独立第三方风险评估报告",
  "xch_00955": "反洗钱主任/合规官的个人简历",
  "xch_00956": "开立账户董事会决议",
  "xch_00957": "公司详细文件",
  "xch_00958": "公司受益人文件",
  "xch_00959": "合规相关文件",
  "xch_00961": "文件审核失败，请重新提交。",
  "xch_00962": "感谢选择PAN-ASIA的人民币清结算系统为您提供服务。根据持牌金融机构间合作的合规性要求，需要您根据以下几步的指引提供更多信息，让我们快速了解贵公司的基本情况。",
  "xch_00963": "请输入公司名称",
  "xch_00964": "根据金融机构合规性要求，我们需要收集一些关于贵公司的详细信息，用于评估贵公司的业务情况和资质，确保符合金融监管的要求。所有信息将严格保密并妥善存放。",
  "xch_00966": "提交成功！",
  "xch_00967": "请点击跳转至待办内容或资料进行查看和填写。如有任何疑问，请随时联系您的客户经理。",
  "xch_00968": "欢迎回来",
  "xch_00969": "您还剩下 {0} 个步骤需要完成",
  "xch_00970": "请跳转至未完成步骤继续填写/上传",
  "xch_00971": "继续填写/上传",
  "xch_00972": "我们建议您按照以下清单准备相关文件。这将大大节省您的时间。",
  "xch_00979": "点击填写在线签字人信息",
  "xch_00980": "可以邀请其他授权人员签字。",
  "xch_00981": "保存失败，您编辑的内容已过时，请检查内容并重新保存。",
  "xch_00984": "保存并提交预审",
  "xch_00985": "缺少必填字段",
  "xch_00986": "必须由董事或授权签字人签署",
  "xch_00987": "须提供所有董事及最终受益人的有效身份证明文件和有效地址证明文件（最终受益人是指通过直接或者间接方式持有、控制当前公司股权或表决权比例合计达到25%及以上的自然人。）",
  "xch_00988": "如果没有最终受益人持有超过25%的股份，请提供公司最终控制人的护照照片和有效地址证明。",
  "xch_00989": "由当地监管机构颁发的金融支付许可证或营业执照",
  "xch_00990": "请提供最新版本",
  "xch_00991": "如有，请提供最新版本",
  "xch_00992": "您可以使用公司决议，或 {0} 进行填写和确认。",
  "xch_00993": "我已准备好，立即申请",
  "xch_00994": "下载模板",
  "xch_00995": "欢迎您",
  "xch_00996": "恭喜您已经成功注册并登录PAN-ASIA交易管理系统。在正式使用前，按照国际间对于持牌金融机构的合规性要求，您需要在随后的工作流中完成客户准入流程。",
  "xch_00997": "每个步骤都会清楚地指示需要上传或填写的位置。",
  "xch_00998": "请准备以下电子文档，格式包括 JPG、PDF、DOC 等。",
  "xch_00999": "内容在{0}自动保存到云端",
  "xch_01000": "填写问卷",
  "xch_01001": "您的填写率未达标，确定提交吗？高填写率能提高审核成功率！",
  "xch_01002": "确认提交",
  "xch_01003": "如有",
  "xch_01004": "包含公司名称或品牌名称的现场办公室照片",
  "xch_01005": "股权结构图（必须由董事或代表签署）、最终受益人的身份证明文件（持有25%以上股份的最终受益人的护照照片和有效地址证明）、以及实际控制人的身份信息（如果没有持有25%以上股份的最终受益人，则提供公司实际控制人的护照照片和有效地址证明）。",
  "xch_01007": "如果您持有25%或以上的股份，请提供最新版本。",
  "xch_01008": "反洗钱/反恐怖融资/制裁问卷",
  "xch_01009": "尽职调查问卷",
  "xch_01010": "需填写",
  "xch_01011": "我们建议您在开始之前，根据以下清单准备好相关文件。这将大大节省您的时间。如果您在过程中遇到任何问题，请随时联系您的客户经理。",
  "xch_01012": "审查进度",
  "xch_01013": "审核完成",
  "xch_01014": "审核中",
  "xch_01015": "已拒绝",
  "xch_01016": "邀请失败，请重新邀请或联系您的专属客户经理。",
  "xch_01018": "请输入您的姓名！",
  "xch_01019": "请输入您的邮箱地址！",
  "xch_01022": "去填写",
  "xch_01023": "您已填写并签署",
  "xch_01024": "等待签署完成",
  "xch_01025": "填写签署人信息",
  "xch_01027": "根据金融机构合规要求，我们需要通过问卷调查了解贵公司在业务合规和反洗钱/反恐融资方面的实践和详细信息。这确保贵公司符合金融法规，也是我们向贵公司提供服务的必要条件。所有信息将严格保密并安全存储。",
  "xch_01028": "股权结构图（必须由董事或其代表签字）",
  "xch_01029": "最终受益人身份证明文件（持有超过25%股份的最终受益人的护照照片和有效地址证明）",
  "xch_01030": "实际控制人身份信息（如果没有最终受益人持有公司25%以上的股份，请提供公司最终控制人的护照照片和有效地址证明）",
  "xch_01031": "许可证证明（由当地监管机构颁发的金融支付许可证或营业执照）",
  "xch_01032": "反洗钱/反恐融资政策（请提供最新版本）",
  "xch_01033": "独立第三方风险评估报告（如有，请提供最新版本）",
  "xch_01034": "反洗钱专员/合规专员简历",
  "xch_01035": "董事会决议开设账户",
  "xch_01036": "反洗钱/反恐融资/制裁问卷（需填写）",
  "xch_01037": "尽职调查表（待填写）",
  "xch_01038": "请仔细阅读并{0}相关内容，填写完成后请{1}预审，预审通过后请由授权人进行在线签署。",
  "xch_01039": "保存并提交预审",
  "xch_01040": "发生错误，请刷新页面重试。",
  "xch_01043": "问卷附件",
  "xch_01044": "上传辅助性说明文件（例如：业务流程图）",
  "xch_01045": "问卷待您填写并提交，以便进行初步审核。",
  "xch_01046": "您的问卷正在初步审核中",
  "xch_01047": "问卷已初步审核完毕，等待您的签字确认。",
  "xch_01048": "立即签署",
  "xch_01049": "顶部",
  "xch_01050": "底部",
  "xch_01051": "预审核不通过，原因: {0}",
  "xch_01052": "请上传图片格式（JPEG、PNG 等）或 PDF 格式的文件。",
  "xch_01087": "业务性质",
  "xch_01088": "请输入行业详细名称",
  "xch_01090": "CNY 模式",
  "xch_01091": "跨币种模式",
  "xch_01092": "原币种模式",
  "xch_01093": "暂不考虑",
  "xch_01094": "缺少材料信息",
  "xch_01110": "提交完成",
  "xch_01186": "钱包模式",
  "xch_01187": "如果您希望通过支付宝/微信收款",
  "xch_01188": "收款人姓名（拼音）",
  "xch_01189": "收款人身份证号码",
  "xch_01190": "收款人：支付宝/微信ID",
  "xch_01218": "香港签证身份文件",
  "xch_01219": "驾照",
  "xch_01220": "免许证",
  "xch_01221": "内地旅行证（香港/澳门）",
  "xch_01222": "健康保险卡",
  "xch_01223": "身份证",
  "xch_01224": "香港临时身份证",
  "xch_01225": "个人通知卡",
  "xch_01226": "大陆入境许可（单次）",
  "xch_01227": "临时文件",
  "xch_01228": "护照",
  "xch_01229": "个人番号卡",
  "xch_01230": "居留许可",
  "xch_01231": "居留卡",
  "xch_01232": "居民证明",
  "xch_01233": "自拍",
  "xch_01234": "香港/澳门至内地通行证",
  "xch_01235": "签证",
  "xch_01247": "点击查看",
  "xch_01290": "状态说明",
  "xch_01291": "描述",
  "xch_01292": "待商家完成上传认证材料。",
  "xch_01293": "待转账。只有在此状态下才能转账。",
  "xch_01294": "由于材料不全，订单需要重新提交。",
  "xch_01295": "提交成功，由xCurency Hubs 团队进行处理",
  "xch_01296": "汇款进行中",
  "xch_01297": "汇款指令已执行，但汇款到账用户账户仍需银行最终处理。",
  "xch_01298": "汇款已完成。用户已收到款项。",
  "xch_01299": "转账失败，跨币种交易模式将退款",
  "xch_01300": "发件人合规信息未获批准或出于风险控制等原因。",
  "xch_01301": "付款已取消",
  "xch_01302": "款项已退还",
  "xch_01327": "换汇金额超限，请联系你的专属客户经理！",
  "xch_01339": "个人薪酬/赡家款",
  "xch_01340": "企业发薪",
  "xch_01341": "商品贸易",
  "xch_01342": "服务贸易",
  "xch_01343": "留学汇款",
  "xch_01344": "其他",
  "xch_01345": "选择产品",
  "xch_01346": "请问您计划使用PAN-ASIA何种产品？",
  "xch_01347": "请选择PAN-ASIA相应的产品帮助我们为您提供更加贴心的服务，可多选。",
  "xch_01348": "是否持有金融牌照",
  "xch_01351": "业务文件",
  "xch_01352": "个人薪酬 - 工资单/税单",
  "xch_01353": "提交样例证明材料 * 1",
  "xch_01354": "货物贸易 - PI",
  "xch_01355": "货物贸易 - 物流单",
  "xch_01356": "服务贸易 - 相关合同",
  "xch_01357": "企业发薪 - 员工合同",
  "xch_01358": "企业发薪 - 员工名单",
  "xch_01359": "提交聘用合同任选 2 份",
  "xch_01360": "个人赡家款 - 关系证明材料",
  "xch_01361": "业务开展国家/地区",
  "xch_01363": "感谢您的注册！我们的团队将尽快完成后台审核，并会有专业人员与您联系。审核通过后，您将享有完整的访问权限。感谢您的耐心等待。如有任何疑问，请随时联系我们",
  "xch_01460": '公司注册号',
  "xch_01515": "现汇买入",
  "xch_01516": "现钞买入",
  "xch_01517": "现汇卖出",
  "xch_01518": "现钞卖出",
  "xch_01519": "中间价",
  "xch_01588": "提款失败",
  "xch_01589": "未找到提现钱包，请联系您的账户经理。",
  "xch_01609": "银行转账",
  "xch_01610": "柜台现金/刷卡交易",
  "xch_01611": "PayNow",
  "xch_01612": "NETS",
  "xch_01613": "最终受益人姓名（与证件一致）",
  "xch_01614": "出生日期",
  "xch_01615": "请填写与上述 UBO 信息文件一致的受益人身份信息。",
  "xch_01616": "男",
  "xch_01617": "女",
  "xch_01618": "最终受益人信息",
  "xch_01619": "身份信息",
  "xch_01620": "请选择",
  "xch_01621": "请选择日期",
  "xch_01622": "请输入",
  "xch_01623": "持股比例（%）",
  "xch_01624": "填写 1–100 表示持股百分比（例如 25% 填 25）。提交后将按 0–1 小数保存。",
  "xch_01625": "请输入 1 到 100 之间的数值",
  "xch_01626": "添加受益人",
  "xch_01627": "移除此受益人",
  "xch_01628": "受益人 {0}",
  "xch_01629": "所有受益人持股比例合计不能超过 100%"
}